module.exports = __webpack_public_path__ + "media/images/massage/card-desktop@3x-6e59bac4ac5d62290174ced76363265e.jpg";